import { Pipe, PipeTransform, inject } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

import { PhoneValidatorService } from '@main-application/shared/services/phone-validator.service';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  private mask: NgxMaskPipe = inject(NgxMaskPipe);
  private phoneValidatorService: PhoneValidatorService = inject(PhoneValidatorService);

  transform(value: string): string {
    const initValue = value?.length ? value : '';
    const { phoneNumber, phoneCode } = this.phoneValidatorService.parsePhoneNumber(value, false);
    const { maskPattern, validPhoneNumberLength } = this.phoneValidatorService.onGetMaskPattern(phoneCode);

    const masked = phoneNumber ? this.mask.transform(phoneNumber, maskPattern) : '';

    const extra =
      phoneNumber && phoneNumber.length > validPhoneNumberLength ? phoneNumber.slice(validPhoneNumberLength) : '';
    return phoneCode ? `+${phoneCode} ${masked}${extra}` : phoneNumber || initValue;
  }
}
